var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "share-container" }, [
    _c(
      "a",
      {
        staticClass: "share",
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.preventDefault()
            _vm.visible = !_vm.visible
          }
        }
      },
      [_vm._v("Share")]
    ),
    _vm._v(" "),
    _c("ul", { staticClass: "share-list", class: { visible: _vm.visible } }, [
      _c("li", { staticClass: "title" }, [_vm._v("Share to")]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            staticClass: "btn-like ifb",
            attrs: { href: _vm.sharerLink("facebook") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.openShare("facebook")
              }
            }
          },
          [_vm._v("Facebook")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            staticClass: "btn-like itw",
            attrs: { href: _vm.sharerLink("twitter") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.openShare("twitter")
              }
            }
          },
          [_vm._v("Twitter")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            staticClass: "btn-like iin",
            attrs: { href: _vm.sharerLink("linkedin") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.openShare("linkedin")
              }
            }
          },
          [_vm._v("Linkedin")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            staticClass: "btn-like iem",
            attrs: { href: _vm.sharerLink("email") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.openEmail("email")
              }
            }
          },
          [_vm._v("Email")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "copy" }, [
        _c(
          "a",
          {
            staticClass: "btn-main",
            attrs: { href: _vm.href() },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.doCopy($event)
              }
            }
          },
          [_vm._v("Copy to clipboard")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }